/* import __COLOCATED_TEMPLATE__ from './content.hbs'; */
import Component from '@glimmer/component';

import type { BvBtnSignature } from './index';
import type { TSize } from 'volta/utils/style-utils';
import type { TTooltipSide, TooltipContent } from '../bv-tooltip';
import type { TText } from 'volta/utils/text-utils';

export interface BvBtnContentSignature {
  Args: {
    asyncAction: unknown;
    disclosure?: BvBtnSignature['Args']['disclosure'];
    iconLeft?: string;
    iconLeftColor?: BvBtnSignature['Args']['iconLeftColor'];
    iconRight?: string;
    iconRightColor?: BvBtnSignature['Args']['iconRightColor'];
    isBusy?: boolean;
    loadingProgress?: number;
    pressed?: boolean;
    size?: TSize;
    text?: TText;
    tooltip?: TooltipContent[] | TText;
    tooltipSide?: TTooltipSide;
    tooltipText?: TText;
  };
  Blocks: {
    default: [unknown];
  };
}

export default class BvBtnContentComponent extends Component<BvBtnContentSignature> {
  // Only way to handle polymorphic types
  get tooltipContent() {
    const { tooltip } = this.args;
    if (typeof tooltip === 'string') {
      return undefined;
    }
    return tooltip as TooltipContent[];
  }

  // Only way to handle polymorphic types
  get tooltipText() {
    const { tooltip, tooltipText } = this.args;
    if (typeof tooltip === 'string') {
      return tooltip;
    }
    return tooltipText;
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'BvBtn::Content': typeof BvBtnContentComponent;
    'bv-btn/content': typeof BvBtnContentComponent;
  }
}
